// import { useLocation, Link, useNavigate } from 'react-router-dom';
// import Footer from '../navbarv2/footer';
// import React, { useEffect, useState } from 'react';
// import QRCode from 'react-qr-code';
// import Navbar from '../navbarv2/navbar';
// import Swal from 'sweetalert2'; // นำเข้า SweetAlert2
// import { API_ENDPOINT } from '../auth/config';
// // import { obfuscateCode } from '../auth/obfuscateCode';

// function Promptpay() {
//     const location = useLocation();
//     const { state } = location;
//     const [remainingTime, setRemainingTime] = useState(300); // Initial value of 5 minutes in seconds
//     const [isExpired, setIsExpired] = useState(false);
//     const [selectedId, setselectedId] = useState(['']);
//     const navigate = useNavigate();
//     const [isCheckPaymentEnabled, setIsCheckPaymentEnabled] = useState(true);
//     useEffect(() => {
//         setselectedId(state.idOrder);
//     }, [state.idOrder]);
//     // เมื่อ selectedId เปลี่ยนแปลง, บันทึกค่าลง localStorage

//     const handleCancel = (id) => {
//         // console.log(id)
//         const myHeaders = new Headers();
//         myHeaders.append("Content-Type", "application/json");
//         myHeaders.append("X-API-KEY", localStorage.getItem('apikey'));
//         const raw = JSON.stringify({
//             "order_id": id
//         });

//         const requestOptions = {
//             method: "POST",
//             headers: myHeaders,
//             body: raw,
//             redirect: "follow"
//         };

//         fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/online-order-cancel`, requestOptions)
//             .then(response => response.json())
//             .then(result => {
//                 if (result.status === "cancel") {
//                     Swal.fire({
//                         title: 'ยกเลิกการชำระเงิน',
//                         text: 'คุณต้องการยกเลิกการชำระเงินนี้หรือไม่?',
//                         icon: 'warning',
//                         showCancelButton: true,
//                         confirmButtonColor: '#3085d6',
//                         cancelButtonColor: '#d33',
//                         confirmButtonText: 'ใช่',
//                         cancelButtonText: 'ไม่ใช่'
//                     }).then((result) => {
//                         if (result.isConfirmed) {
//                             Swal.fire(
//                                 'ยกเลิกแล้ว!',
//                                 'รายการของคุณถูกยกเลิกแล้ว',
//                                 'success'
//                             ).then(() => {
//                                 navigate('/OrderList'); // เปลี่ยนเส้นทางไปยังหน้า /OrderList
//                             });
//                         }
//                     });
//                 } else {


//                 }
//             })
//             .catch((error) => console.error(error));
//     };
//     const autoleCancel = (id) => {
//         // console.log(id)
//         const myHeaders = new Headers();
//         myHeaders.append("Content-Type", "application/json");
//         myHeaders.append("X-API-KEY", localStorage.getItem('apikey'));
//         const raw = JSON.stringify({
//             "order_id": id
//         });

//         const requestOptions = {
//             method: "POST",
//             headers: myHeaders,
//             body: raw,
//             redirect: "follow"
//         };

//         fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/online-order-cancel`, requestOptions)
//             .then(response => response.json())
//             .then(result => {
//                 if (result.status === "cancel") {
//                     Swal.fire({
//                         title: 'เกินเวลาที่กำหนด!',
//                         text: 'รายการของคุณถูกยกเลิกแล้ว',
//                         icon: 'error', // เปลี่ยนเป็น 'error' สำหรับข้อผิดพลาด
//                         confirmButtonText: 'ตกลง'
//                     }).then(() => {
//                         navigate('/OrderList'); // เปลี่ยนเส้นทางไปยังหน้า /OrderList
//                     });
//                 } else {
//                     // เรียกใช้ฟังก์ชัน obfuscateCode

//                     //  const obfuscatedCode = obfuscateCode('notsuccessful');

//                     //  // แสดงผลลัพธ์ในคอนโซล
//                     //  console.log('Obfuscated Code:', obfuscatedCode);
//                 }
//             })
//             .catch((error) => console.error(error));
//     };

//     useEffect(() => {
//         const calculateRemainingTime = () => {
//             const createdAt = new Date(state.createdAt);
//             const now = new Date();
//             const timeElapsed = Math.floor((now - createdAt) / 1000); // Time elapsed in seconds
//             const timeLeft = 300 - timeElapsed; // 300 seconds is the initial countdown duration

//             if (timeLeft <= 0) {
//                 setIsExpired(true);
//                 const myHeaders = new Headers();
//                 myHeaders.append("Content-Type", "application/json");
//                 myHeaders.append("X-API-KEY", localStorage.getItem('apikey'));
//                 const raw = JSON.stringify({
//                     "order_id": selectedId
//                 });

//                 const requestOptions = {
//                     method: "POST",
//                     headers: myHeaders,
//                     body: raw,
//                     redirect: "follow"
//                 };

//                 fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/online-order-cancel`, requestOptions)
//                     .then(response => response.json())
//                     .then(result => {
//                         if (result.status === "cancel") {

//                         } else {

//                         }
//                     })
//                     .catch((error) => console.error(error));
//                 return 0;
//             }

//             return timeLeft;
//         };



//         // Set initial remaining time
//         setRemainingTime(calculateRemainingTime());

//         const timer = setInterval(() => {
//             // checkPayment();
//             setRemainingTime(prevTime => {
//                 if (prevTime <= 1) {
//                     clearInterval(timer);
//                     setIsExpired(true);
//                     return 0;
//                 }
//                 return prevTime - 1;
//             });
//         }, 2000); // Update every second

//         return () => clearInterval(timer); // Cleanup interval on component unmount
//     }, [navigate, selectedId, state.createdAt, state.ref, state.ref2]);

//     const formatTime = (seconds) => {
//         const minutes = Math.floor(seconds / 60);
//         const secs = seconds % 60;
//         return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
//     };
//     if (!isExpired) {

//     } else {
//         autoleCancel(selectedId);
//     }




//     const checkPayment = () => {
//         if (!isCheckPaymentEnabled) return;

//         // Disable the button
//         setIsCheckPaymentEnabled(false);

//         // Logic to check payment...
//         console.log('กำลังตรวจสอบการชำระเงิน');

//         // Simulate an API call with setTimeout
//         setTimeout(() => {
//             // Here you can handle the response and show results

//             // Re-enable the button after 5 seconds
//             setIsCheckPaymentEnabled(true);
//         }, 5000);
//         const myHeaders = new Headers();
//         myHeaders.append("Content-Type", "application/json");
//         myHeaders.append("X-API-KEY", localStorage.getItem('apikey'));
//         const raw = JSON.stringify({
//             "ref1": state.ref,
//             "ref2": state.ref2
//         });

//         const requestOptions = {
//             method: "POST",
//             headers: myHeaders,
//             body: raw,
//             redirect: "follow"
//         };

//         fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/check_payment`, requestOptions)
//             .then(response => {
//                 if (response.status === 401) {
//                     // แสดง SweetAlert2 ถ้าสถานะเป็น 401
//                     Swal.fire({
//                         icon: 'error',
//                         title: 'Unauthorized',
//                         text: 'พบปัญหาระหว่างตรวจสอบผู้ใช้งาน กรุณาออกจากระบบและเข้าระบบอีกครั้ง',
//                         confirmButtonText: 'ตกลง'
//                     }).then(() => {
//                         navigate('/home'); // เปลี่ยนเส้นทางไปยังหน้าโฮม
//                     });
//                     // หยุดการดำเนินการต่อในกรณีที่ได้รับสถานะ 401
//                     return Promise.reject('Unauthorized');
//                 }

//                 // แปลงการตอบกลับเป็น JSON
//                 return response.json();
//             })
//             .then(result => {
//                 if (result.respMsg === "Unsuccess") {
//                     // ถ้าข้อความตอบกลับเป็น "Unsuccess" ให้แสดงข้อความข้อผิดพลาด (สามารถเพิ่มการจัดการเพิ่มเติมได้ที่นี่)
//                     Swal.fire({
//                         title: 'Payment Unsuccessful',
//                         text: 'ยังไม่มีการชำระเงิน ขออภัยหากชำระเงินแล้วกรุณาแจ้งเจ้าหน้าที่',
//                         icon: 'error',
//                         confirmButtonText: 'ตกลง'
//                     });
//                 } else {
//                     // ถ้าการชำระเงินสำเร็จ
//                     // clearInterval(timer); // หยุดตัวจับเวลา

//                     // แสดงการแจ้งเตือนเมื่อชำระเงินสำเร็จ
//                     Swal.fire({
//                         title: 'Payment Successful',
//                         text: 'Your payment was successful!',
//                         icon: 'success',
//                         confirmButtonText: 'OK'
//                     }).then((result) => {
//                         if (result.isConfirmed) {
//                             // เปลี่ยนเส้นทางไปยังหน้า /OrderList
//                             navigate('/OrderList');
//                         }
//                     });
//                 }
//             })
//             .catch(error => {
//                 // จัดการข้อผิดพลาดทั่วไป
//                 console.error('Error:', error);
//                 //   Swal.fire({
//                 //     icon: 'error',
//                 //     title: 'Error',
//                 //     text: 'เกิดข้อผิดพลาดในการตรวจสอบการชำระเงิน',
//                 //     confirmButtonText: 'ตกลง'
//                 //   });
//             });

//     }

//     const Testapprove = (ref1, ref2) => {
//         const myHeaders = new Headers();
//         myHeaders.append("Content-Type", "application/json");
//         myHeaders.append("X-API-KEY", localStorage.getItem('apikey'));

//         const raw = JSON.stringify({
//             "ref1": { ref1 },
//             "ref2": { ref2 }
//         });

//         const requestOptions = {
//             method: "POST",
//             headers: myHeaders,
//             body: raw,
//             redirect: "follow"
//         };

//         fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/test_approve`, requestOptions)
//             .then((response) => response.text())
//             .then((result) => console.log(result))
//             .catch((error) => console.error(error));
//     }



//     const [showModal, setShowModal] = useState(false);
//     const [formData, setFormData] = useState({
//         name: "",
//         phone: "",
//     });

//     useEffect(() => {
//         // ตรวจสอบว่าถ้า date ตรงกับ 2025-01-11 จะแสดง Modal
//         if (state.date === "2025-01-11") {
//             setShowModal(true);
//         }
//     }, [state.date]);

//     const handleCloseModal = () => {
//         setShowModal(false);
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevData) => ({ ...prevData, [name]: value }));
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
        
//         const myHeaders = new Headers();
//         myHeaders.append("Content-Type", "application/json");
//         myHeaders.append("X-API-KEY", "PJV||2f2ee368bca7ae0df1582003c1");

//         const raw = JSON.stringify({
//             "ref": state.ref,
//             "name": formData.name,
//             "phone_number": formData.phone,
//             "line_token": localStorage.getItem('token'),
//             "zoo_id": state.idzoo,
//             "user_id": localStorage.getItem('userid'),
//             "reward_date": state.date
//         });

//         const requestOptions = {
//             method: "POST",
//             headers: myHeaders,
//             body: raw,
//             redirect: "follow"
//         };

//         fetch("https://addpaycrypto.com/zoo/zoo-api/service/?service=add_number", requestOptions)
//             .then((response) => response.json())
//             .then((result) => {
//                 if (result.status === true) {
//                     Swal.fire({
//                         icon: 'success',
//                         title: 'ยืนยันสำเร็จ',
//                         text: `ยืนยันการรับสิทธิ์แล้ว: ชื่อ ${formData.name}, เบอร์โทร ${formData.phone}`,
//                         confirmButtonText: 'ตกลง'
//                     }).then(() => {
//                         setShowModal(false); // ปิด Modal หลังจากส่งข้อมูล
//                     });
//                 } else {
//                     Swal.fire({
//                         icon: 'error',
//                         title: 'เกิดข้อผิดพลาด',
//                         text: 'ไม่สามารถยืนยันการรับสิทธิ์ได้',
//                         confirmButtonText: 'ลองอีกครั้ง'
//                     }).then(() => {
//                         setShowModal(false); // ปิด Modal หลังจากส่งข้อมูล
//                     });
//                 }
//             })
//             .catch((error) => console.error(error));
//     };


//     return (
//         <div>
//             <Navbar />


//             {showModal && (
//                 <div
//                     className="modal fade show"
//                     tabIndex="-1"
//                     aria-hidden="true"
//                     style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.8)" }}
//                 >
//                     <div className="modal-dialog modal-lg">
//                         <div className="modal-content">
//                             <div className="modal-header">
//                                 <h5 className="modal-title">
//                                     ยินดีด้วย! คุณได้รับสิทธิ์ลุ้นรางวัล
//                                 </h5>
//                                 <button
//                                     type="button"
//                                     className="btn-close"
//                                     aria-label="Close"
//                                     onClick={handleCloseModal}
//                                 ></button>
//                             </div>
//                             <div className="modal-body">
//                                 <p>
//                                     ยินดีด้วย คุณซื้อบัตรเข้าชมในวันที่{" "}
//                                     <strong>11 มกราคม 2568 (วันเด็กแห่งชาติ)</strong>
//                                     คุณได้รับสิทธิ์ลุ้นรางวัล!
//                                 </p>
//                                 <p>กรุณากรอกชื่อและเบอร์โทรเพื่อยืนยันการรับสิทธิ์:</p>
//                                 <div className="container mt-3 text-center fs-10 ">
//                                     <p className='text-danger'>*****เงื่อนไขหากคุณถูกรางวัล ให้ส่งสลิปการชำระงินเพื่อยืนยันผ่าน line Zoo E-Ticket By @pay หรื่อที่ เพจ facbook:Zoo E-ticket by Addpay ******</p>
//                                 </div>
//                                 <form onSubmit={handleSubmit}>
//                                     <div className="mb-3">
//                                         <label htmlFor="name" className="form-label">
//                                             ชื่อ:
//                                         </label>
//                                         <input
//                                             type="text"
//                                             id="name"
//                                             name="name"
//                                             className="form-control"
//                                             value={formData.name}
//                                             onChange={handleInputChange}
//                                             required
//                                         />
//                                     </div>
//                                     <div className="mb-3">
//                                         <label htmlFor="phone" className="form-label">
//                                             เบอร์โทร:
//                                         </label>
//                                         <input
//                                             type="tel"
//                                             id="phone"
//                                             name="phone"
//                                             className="form-control"
//                                             value={formData.phone}
//                                             onChange={handleInputChange}
//                                             required
//                                         />
//                                     </div>
//                                     <button type="submit" className="btn btn-primary">
//                                         ยืนยันสิทธิ์
//                                     </button>
//                                 </form>
//                             </div>
//                             <div className="modal-footer">
//                                 <button
//                                     className="btn btn-danger"
//                                     onClick={handleCloseModal}
//                                 >
//                                     ไม่รับสิทธิ์
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//             {/* <p>{state.ref}</p>
//             <p>{state.ref2}</p>
      
//             <p>{state.qrData}</p>
//             <p>{state.total}</p>
//             <p>{state.createdAt}</p>  */}
//             <div className=" container px-5 mt-5 text-center">
//                 {!isExpired ? (
//                     <>
//                         <div className="countdown-container">
//                             <p className="countdown-text">เวลาชำระเงิน:</p>
//                             <div className="countdown-timer">{formatTime(remainingTime)}</div>
//                         </div>

//                         <div className='container' >
//                             <div className='container' style={{ textAlign: 'center', color: '#0C9331', fontSize: 25, fontFamily: 'Kanit', fontWeight: '400' }}>
//                                 แสกน QR เพื่อชำระเงิน
//                             </div>
//                             <div className="mt-3 text-center fs-4 fw-light">
//                                 เลขที่คำสั่งซื้อ : {state.ref}
//                             </div>

//                             <div className='container text-center mt-5' >
//                                 <QRCode size={150} value={state.qrData} />
//                             </div>
//                             <div className="container mt-3 text-center fs-10 ">
//                                 <p className='text-danger'>*****กรุณาอย่ากดออกจากหน้าจอนี้ ในระหว่างการชำระงิน เพื่อไม่ให้การชำระเงินเกิดข้อผิดพลาด*******</p>
//                             </div>
//                             {/* <button onClick={() => Testapprove(state.ref, state.ref2)} className="btn btn-primary mt-3">
//                                 Test Approve
//                             </button> */}
//                             <button
//                                 onClick={checkPayment}
//                                 className="btn btn-primary mt-3"
//                                 disabled={!isCheckPaymentEnabled} // Disable if not enabled
//                             >
//                                 ตรวจสอบการชำระเงินของคุณ
//                             </button>

//                             {/* <div className='container text-center mt-5'>
//                             <h3>Ref 1:{state.ref}</h3>
                        
//                             </div>
//                             <div className='container text-center mt-5'>
//                             <h3>Ref 2:{state.ref2}</h3>
//                             </div> */}
//                             <div className='container mt-5' style={{ textAlign: 'center', color: '#7C7C7C', fontSize: 30, fontFamily: 'Kanit', fontWeight: '400', wordWrap: 'break-word' }}>
//                                 ยอดชำระ {state.total} บาท
//                             </div>

//                             <div className="container mt-5" style={{ textAlign: 'center' }}>
//                                 <button
//                                     className="btn btn-danger  btn-block"
//                                     onClick={() => handleCancel(selectedId)}
//                                     style={{
//                                         background: 'linear-gradient(180deg, #E11010 0%, #C90848 63%)',
//                                         borderRadius: 124,
//                                         border: '2px #F10E0E solid'
//                                     }}
//                                 >
//                                     ยกเลิกการชำระเงิน
//                                 </button>
//                             </div>
//                         </div>
//                     </>
//                 ) : (
//                     <div className="expired-message">
//                         <p>หมดเวลาสำหรับการชำระเงินของรายการนี้</p>
//                         <Link to="/addticket" type="button" className="btn  btn-lg btn btn-primary "  >ทำรายการใหม่</Link>
//                     </div>
//                 )}
//             </div>

//             <Footer></Footer>
//         </div>
//     );
// }

// export default Promptpay;






import { useLocation, Link, useNavigate } from 'react-router-dom';
import Footer from '../navbarv2/footer';
import React, { useEffect, useState, useRef } from 'react';
import QRCode from 'react-qr-code';
import Navbar from '../navbarv2/navbar';
import Swal from 'sweetalert2';
import { API_ENDPOINT } from '../auth/config';

/* ─────────── STYLES ─────────── */
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;500;600;700&family=DM+Serif+Display:ital@0;1&display=swap');

  :root {
    --bg:        #070d1a;
    --surface:   #0f1c32;
    --surface2:  #152238;
    --border:    rgba(255,255,255,0.07);
    --green:     #22c55e;
    --green-dim: rgba(34,197,94,0.12);
    --green-glow:rgba(34,197,94,0.35);
    --red:       #ef4444;
    --gold:      #f59e0b;
    --text:      #f1f5f9;
    --muted:     #64748b;
    --font:      'Sarabun', sans-serif;
  }

  .pp-page {
    min-height: 100vh;
    background: var(--bg);
    color: var(--text);
    padding-bottom: 60px;
  }

  /* ── HERO BAND ── */
  .pp-hero {
    background: linear-gradient(160deg, #0b1829 0%, #071020 100%);
    border-bottom: 1px solid var(--border);
    padding: 32px 24px 28px;
    text-align: center;
    position: relative;
    overflow: hidden;
  }

  .pp-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse 60% 60% at 50% -10%, rgba(34,197,94,0.12) 0%, transparent 70%);
    pointer-events: none;
  }

  .pp-hero-label {
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--green);
    margin-bottom: 8px;
  }

  .pp-hero-title {
    font-size: clamp(1.5rem, 4vw, 2rem);
    color: var(--text);
    margin: 0 0 4px;
  }

  .pp-hero-ref {
    font-size: 0.8rem;
    color: var(--muted);
    letter-spacing: 0.05em;
  }

  .pp-hero-ref span {
    color: #94a3b8;
    font-weight: 600;
  }

  /* ── MAIN CARD ── */
  .pp-wrap {
    max-width: 480px;
    margin: 28px auto 0;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    animation: ppFadeUp 0.5s cubic-bezier(0.22,1,0.36,1) both;
  }

  @keyframes ppFadeUp {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .pp-card {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 20px;
    overflow: hidden;
  }

  .pp-card-header {
    padding: 16px 20px;
    border-bottom: 1px solid var(--border);
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .pp-card-icon {
    width: 30px; height: 30px;
    border-radius: 8px;
    background: var(--green-dim);
    border: 1px solid rgba(34,197,94,0.2);
    display: flex; align-items: center; justify-content: center;
    font-size: 0.9rem;
    flex-shrink: 0;
  }

  .pp-card-title {
    font-size: 0.875rem;
    font-weight: 700;
    color: #e2e8f0;
  }

  /* ── TIMER ── */
  .pp-timer-wrap {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .pp-timer-label {
    font-size: 0.75rem;
    color: var(--muted);
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .pp-timer-ring {
    position: relative;
    width: 100px;
    height: 100px;
  }

  .pp-timer-ring svg {
    transform: rotate(-90deg);
    position: absolute; inset: 0;
  }

  .pp-timer-ring circle.track {
    fill: none;
    stroke: rgba(255,255,255,0.06);
    stroke-width: 6;
  }

  .pp-timer-ring circle.fill {
    fill: none;
    stroke-width: 6;
    stroke-linecap: round;
    transition: stroke-dashoffset 1s linear, stroke 0.5s;
    stroke: var(--green);
  }

  .pp-timer-ring circle.fill.warn  { stroke: var(--gold); }
  .pp-timer-ring circle.fill.crit  { stroke: var(--red); }

  .pp-timer-val {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    font-weight: 800;
    color: var(--text);
    letter-spacing: -0.03em;
  }

  .pp-timer-sub {
    font-size: 0.78rem;
    color: var(--muted);
  }

  /* ── QR BOX ── */
  .pp-qr-wrap {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .pp-qr-frame {
    background: #ffffff;
    border-radius: 16px;
    padding: 16px;
    box-shadow: 0 0 0 1px rgba(255,255,255,0.1), 0 8px 40px rgba(34,197,94,0.2);
    position: relative;
  }

  /* corner deco */
  .pp-qr-frame::before,
  .pp-qr-frame::after {
    content: '';
    position: absolute;
    width: 18px; height: 18px;
    border-color: var(--green);
    border-style: solid;
  }
  .pp-qr-frame::before { top: -1px; left: -1px; border-width: 3px 0 0 3px; border-radius: 4px 0 0 0; }
  .pp-qr-frame::after  { bottom: -1px; right: -1px; border-width: 0 3px 3px 0; border-radius: 0 0 4px 0; }

  .pp-qr-badge {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .pp-qr-badge img {
    height: 28px;
    object-fit: contain;
  }

  .pp-qr-badge-text {
    font-size: 0.78rem;
    color: var(--muted);
  }

  /* ── AMOUNT ── */
  .pp-amount-card {
    background: var(--green-dim);
    border: 1px solid rgba(34,197,94,0.18);
    border-radius: 14px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
  }

  .pp-amount-label {
    font-size: 0.8rem;
    color: #86efac;
    font-weight: 500;
  }

  .pp-amount-value {
    font-size: 1.8rem;
    color: #f1f5f9;
    letter-spacing: -0.02em;
  }

  .pp-amount-value span {
    font-size: 0.9rem;
    color: var(--muted);
    margin-left: 4px;
    font-weight: 400;
  }

  /* ── WARNING BANNER ── */
  .pp-warning {
    background: rgba(245,158,11,0.08);
    border: 1px solid rgba(245,158,11,0.22);
    border-radius: 12px;
    padding: 12px 16px;
    display: flex;
    gap: 10px;
    align-items: flex-start;
    font-size: 0.8rem;
    color: #fde68a;
    line-height: 1.55;
  }

  .pp-warning-icon { font-size: 1rem; flex-shrink: 0; margin-top: 1px; }

  /* ── BUTTONS ── */
  .pp-btn-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .pp-btn-check {
    width: 100%;
    padding: 15px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border: none;
    border-radius: 14px;
    color: #fff;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s, opacity 0.2s;
    box-shadow: 0 4px 20px var(--green-glow);
    display: flex; align-items: center; justify-content: center; gap: 8px;
  }

  .pp-btn-check:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 30px rgba(34,197,94,0.5); }
  .pp-btn-check:disabled { opacity: 0.45; cursor: not-allowed; transform: none; box-shadow: none; }

  .pp-btn-cancel {
    width: 100%;
    padding: 13px;
    background: transparent;
    border: 1.5px solid rgba(239,68,68,0.3);
    border-radius: 14px;
    color: #fca5a5;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
    display: flex; align-items: center; justify-content: center; gap: 8px;
  }

  .pp-btn-cancel:hover { background: rgba(239,68,68,0.08); border-color: rgba(239,68,68,0.5); }

  /* cooldown bar */
  .pp-cooldown-bar {
    height: 3px;
    background: rgba(255,255,255,0.06);
    border-radius: 3px;
    overflow: hidden;
    margin-top: -6px;
  }

  .pp-cooldown-fill {
    height: 100%;
    background: var(--green);
    border-radius: 3px;
    transition: width 0.2s linear;
  }

  /* ── EXPIRED STATE ── */
  .pp-expired {
    text-align: center;
    padding: 48px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .pp-expired-icon {
    width: 72px; height: 72px;
    border-radius: 50%;
    background: rgba(239,68,68,0.12);
    border: 1px solid rgba(239,68,68,0.25);
    display: flex; align-items: center; justify-content: center;
    font-size: 2rem;
  }

  .pp-expired h3 {
    font-size: 1.4rem;
    color: var(--text);
    margin: 0;
  }

  .pp-expired p { font-size: 0.875rem; color: var(--muted); margin: 0; }

  .pp-btn-retry {
    padding: 14px 32px;
    background: var(--surface2);
    border: 1.5px solid var(--border);
    border-radius: 14px;
    color: var(--text);
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
    text-decoration: none;
    display: inline-flex; align-items: center; gap: 8px;
  }

  .pp-btn-retry:hover { background: var(--surface2); border-color: rgba(255,255,255,0.15); color: var(--text); }

  /* ── PRIZE MODAL ── */
  .pp-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.85);
    backdrop-filter: blur(8px);
    z-index: 3000;
    display: flex; align-items: flex-end; justify-content: center;
    animation: ppFadeIn 0.25s ease;
  }

  @keyframes ppFadeIn { from { opacity: 0; } to { opacity: 1; } }

  .pp-modal {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 24px 24px 0 0;
    width: 100%; max-width: 520px;
    max-height: 90vh; overflow-y: auto;
    animation: ppSlideUp 0.4s cubic-bezier(0.22,1,0.36,1);
    padding: 0 0 32px;
  }

  @keyframes ppSlideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }

  .pp-modal-handle {
    display: flex; justify-content: center; padding: 14px 0 4px;
  }
  .pp-modal-handle span { display: block; width: 40px; height: 4px; border-radius: 4px; background: rgba(255,255,255,0.1); }

  .pp-modal-header {
    padding: 14px 24px 18px;
    border-bottom: 1px solid var(--border);
  }

  .pp-modal-trophy {
    font-size: 2.2rem;
    margin-bottom: 8px;
  }

  .pp-modal-title {
    font-size: 1.2rem;
    color: var(--gold);
    margin: 0 0 4px;
  }

  .pp-modal-sub {
    font-size: 0.8rem;
    color: var(--muted);
    line-height: 1.5;
  }

  .pp-modal-body { padding: 20px 24px; display: flex; flex-direction: column; gap: 14px; }

  .pp-modal-notice {
    background: rgba(239,68,68,0.08);
    border: 1px solid rgba(239,68,68,0.2);
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 0.78rem;
    color: #fca5a5;
    line-height: 1.55;
  }

  .pp-field label {
    display: block;
    font-size: 0.78rem;
    font-weight: 600;
    color: #94a3b8;
    margin-bottom: 6px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .pp-field input {
    width: 100%;
    padding: 12px 16px;
    background: rgba(255,255,255,0.04);
    border: 1.5px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    color: var(--text);
    font-size: 0.95rem;
    outline: none;
    transition: border-color 0.2s;
    box-sizing: border-box;
  }

  .pp-field input:focus { border-color: rgba(34,197,94,0.5); background: rgba(34,197,94,0.04); }
  .pp-field input::placeholder { color: #334155; }

  .pp-modal-footer {
    padding: 0 24px;
    display: flex; gap: 10px;
  }

  .pp-modal-submit {
    flex: 1; padding: 13px;
    background: linear-gradient(135deg, #f59e0b, #d97706);
    border: none; border-radius: 12px;
    color: #f font-size: 0.95rem; font-weight: 700;
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(245,158,11,0.35);
    transition: transform 0.15s;
  }
  .pp-modal-submit:hover { transform: translateY(-1px); }

  .pp-modal-skip {
    padding: 13px 18px;
    background: transparent; border: 1.5px solid rgba(255,255,255,0.08);
    border-radius: 12px;
    color: var(--mute font-size: 0.875rem;
    cursor: pointer; transition: all 0.15s;
  }
  .pp-modal-skip:hover { border-color: rgba(255,255,255,0.18); color: #94a3b8; }

  /* ── MOBILE ── */
  @media (max-width: 480px) {
    .pp-hero { padding: 24px 16px 20px; }
    .pp-wrap { padding: 0 12px; }
    .pp-amount-value { font-size: 1.5rem; }
    .pp-timer-ring  { width: 86px; height: 86px; }
    .pp-timer-val   { font-size: 1.2rem; }
  }
`;

/* ── ICONS ── */
const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);
const RefreshIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
  </svg>
);

/* ── TIMER RING ── */
const RADIUS = 42;
const CIRC   = 2 * Math.PI * RADIUS;

function TimerRing({ remaining, total = 300 }) {
  const pct      = remaining / total;
  const offset   = CIRC * (1 - pct);
  const colorCls = remaining <= 30 ? 'crit' : remaining <= 90 ? 'warn' : '';

  const mins = Math.floor(remaining / 60);
  const secs = remaining % 60;
  const label = `${mins}:${secs < 10 ? '0' : ''}${secs}`;

  return (
    <div className="pp-timer-ring">
      <svg width="100" height="100" viewBox="0 0 100 100">
        <circle className="track" cx="50" cy="50" r={RADIUS}/>
        <circle
          className={`fill ${colorCls}`}
          cx="50" cy="50" r={RADIUS}
          strokeDasharray={CIRC}
          strokeDashoffset={offset}
        />
      </svg>
      <div className="pp-timer-val">{label}</div>
    </div>
  );
}

/* ─────────── COMPONENT ─────────── */
function Promptpay() {
  const location   = useLocation();
  const { state }  = location;
  const navigate   = useNavigate();

  const [remainingTime, setRemainingTime]             = useState(300);
  const [isExpired, setIsExpired]                     = useState(false);
  const [selectedId, setselectedId]                   = useState('');
  const [isCheckPaymentEnabled, setIsCheckPaymentEnabled] = useState(true);
  const [cooldownPct, setCooldownPct]                 = useState(100);
  const cooldownRef = useRef(null);

  // Prize modal
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData]   = useState({ name: '', phone: '' });

  useEffect(() => {
    setselectedId(state.idOrder);
  }, [state.idOrder]);

  useEffect(() => {
    if (state.date === '2025-01-11') setShowModal(true);
  }, [state.date]);

  /* ── Countdown ── */
  useEffect(() => {
    const calc = () => {
      const elapsed = Math.floor((new Date() - new Date(state.createdAt)) / 1000);
      const left    = 300 - elapsed;
      if (left <= 0) { setIsExpired(true); return 0; }
      return left;
    };

    setRemainingTime(calc());

    const timer = setInterval(() => {
      setRemainingTime(prev => {
        if (prev <= 1) { clearInterval(timer); setIsExpired(true); return 0; }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [state.createdAt]);

  /* ── Auto-cancel on expire ── */
  useEffect(() => {
    if (!isExpired) return;
    cancelOrder(selectedId, true);
  }, [isExpired, selectedId]);

  /* ── Cancel order ── */
  const cancelOrder = (id, auto = false) => {
    const opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-KEY': localStorage.getItem('apikey') },
      body: JSON.stringify({ order_id: id }),
      redirect: 'follow',
    };

    fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/online-order-cancel`, opts)
      .then(r => r.json())
      .then(result => {
        if (result.status !== 'cancel') return;

        if (auto) {
          Swal.fire({
            title: 'หมดเวลา!', text: 'รายการถูกยกเลิกอัตโนมัติ',
            icon: 'error', confirmButtonText: 'ตกลง',
            background: '#0f1c32', color: '#f1f5f9', confirmButtonColor: '#22c55e',
          }).then(() => navigate('/OrderList'));
          return;
        }

        Swal.fire({
          title: 'ยืนยันการยกเลิก', text: 'ต้องการยกเลิกการชำระเงินนี้หรือไม่?',
          icon: 'warning', showCancelButton: true,
          confirmButtonColor: '#22c55e', cancelButtonColor: '#ef4444',
          confirmButtonText: 'ใช่, ยกเลิก', cancelButtonText: 'ไม่, กลับไป',
          background: '#0f1c32', color: '#f1f5f9',
        }).then(r => {
          if (r.isConfirmed) navigate('/OrderList');
        });
      })
      .catch(console.error);
  };

  /* ── Check payment ── */
  const checkPayment = () => {
    if (!isCheckPaymentEnabled) return;
    setIsCheckPaymentEnabled(false);
    setCooldownPct(0);

    // cooldown animation
    let elapsed = 0;
    cooldownRef.current = setInterval(() => {
      elapsed += 200;
      setCooldownPct(Math.min((elapsed / 5000) * 100, 100));
      if (elapsed >= 5000) {
        clearInterval(cooldownRef.current);
        setIsCheckPaymentEnabled(true);
      }
    }, 200);

    const opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-KEY': localStorage.getItem('apikey') },
      body: JSON.stringify({ ref1: state.ref, ref2: state.ref2 }),
      redirect: 'follow',
    };

    fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/check_payment`, opts)
      .then(r => {
        if (r.status === 401) {
          Swal.fire({
            icon: 'error', title: 'Session หมดอายุ',
            text: 'กรุณาออกจากระบบแล้วเข้าสู่ระบบใหม่',
            background: '#0f1c32', color: '#f1f5f9', confirmButtonColor: '#22c55e',
          }).then(() => navigate('/home'));
          return Promise.reject('Unauthorized');
        }
        return r.json();
      })
      .then(result => {
        if (result.respMsg === 'Unsuccess') {
          Swal.fire({
            title: 'ยังไม่พบการชำระเงิน',
            text: 'หากชำระเงินแล้วกรุณารอสักครู่แล้วลองใหม่ หรือแจ้งเจ้าหน้าที่',
            icon: 'warning',
            background: '#0f1c32', color: '#f1f5f9', confirmButtonColor: '#22c55e',
          });
        } else {
          Swal.fire({
            title: '✅ ชำระเงินสำเร็จ!', text: 'ระบบรับการชำระเงินของคุณแล้ว',
            icon: 'success', confirmButtonText: 'ดูรายการ',
            background: '#0f1c32', color: '#f1f5f9', confirmButtonColor: '#22c55e',
          }).then(r => { if (r.isConfirmed) navigate('/OrderList'); });
        }
      })
      .catch(console.error);
  };

  /* ── Prize submit ── */
  const handleSubmit = (e) => {
    e.preventDefault();
    const opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-KEY': 'PJV||2f2ee368bca7ae0df1582003c1' },
      body: JSON.stringify({
        ref: state.ref, name: formData.name, phone_number: formData.phone,
        line_token: localStorage.getItem('token'),
        zoo_id: state.idzoo, user_id: localStorage.getItem('userid'),
        reward_date: state.date,
      }),
      redirect: 'follow',
    };
    fetch('https://addpaycrypto.com/zoo/zoo-api/service/?service=add_number', opts)
      .then(r => r.json())
      .then(result => {
        Swal.fire({
          icon: result.status === true ? 'success' : 'error',
          title: result.status === true ? 'ยืนยันสำเร็จ!' : 'เกิดข้อผิดพลาด',
          text: result.status === true
            ? `รับสิทธิ์แล้ว: ${formData.name} — ${formData.phone}`
            : 'ไม่สามารถยืนยันการรับสิทธิ์ได้',
          background: '#0f1c32', color: '#f1f5f9', confirmButtonColor: '#22c55e',
        }).then(() => setShowModal(false));
      })
      .catch(console.error);
  };

  /* ─── RENDER ─── */
  return (
    <>
      <style>{css}</style>
      <div className="pp-page">
        <Navbar />

        {/* HERO */}
        <div className="pp-hero">
          <div className="pp-hero-label">🔒 PromptPay / QR Code</div>
          <h1 className="pp-hero-title">ชำระเงินผ่าน QR Code</h1>
          <div className="pp-hero-ref">เลขที่คำสั่งซื้อ: <span>{state.ref}</span></div>
        </div>

        <div className="pp-wrap">

          {!isExpired ? (
            <>
              {/* TIMER CARD */}
              <div className="pp-card">
                <div className="pp-card-header">
                  <div className="pp-card-icon">⏱</div>
                  <div className="pp-card-title">เวลาที่เหลือสำหรับชำระเงิน</div>
                </div>
                <div className="pp-timer-wrap">
                  <div className="pp-timer-label">หมดเวลาใน</div>
                  <TimerRing remaining={remainingTime} total={300} />
                  <div className="pp-timer-sub">
                    {remainingTime <= 30
                      ? '⚠️ ใกล้หมดเวลา กรุณาชำระโดยเร็ว'
                      : 'สแกน QR Code ให้เสร็จก่อนหมดเวลา'}
                  </div>
                </div>
              </div>

              {/* QR CARD */}
              <div className="pp-card">
                <div className="pp-card-header">
                  <div className="pp-card-icon">📱</div>
                  <div className="pp-card-title">สแกน QR เพื่อชำระเงิน</div>
                </div>
                <div className="pp-qr-wrap">
                  <div className="pp-qr-frame">
                    <QRCode size={180} value={state.qrData} />
                  </div>
                  <div className="pp-qr-badge">
                    <img src="https://secure1.zimple.cloud/images/thai_qr_payment.png" alt="PromptPay" />
                    <span className="pp-qr-badge-text">รองรับทุกแอปธนาคาร</span>
                  </div>

                  {/* AMOUNT */}
                  <div className="pp-amount-card" style={{ width: '100%', boxSizing: 'border-box' }}>
                    <div className="pp-amount-label">ยอดชำระทั้งหมด</div>
                    <div className="pp-amount-value">
                      ฿{Number(state.total).toLocaleString()}
                      <span>บาท</span>
                    </div>
                  </div>

                  {/* WARNING */}
                  <div className="pp-warning">
                    <span className="pp-warning-icon">⚠️</span>
                    <span>กรุณาอย่ากดออกจากหน้านี้ระหว่างชำระเงิน เพื่อป้องกันข้อผิดพลาดในการประมวลผล</span>
                  </div>
                </div>
              </div>

              {/* ACTION BUTTONS */}
              <div className="pp-btn-row">
                <button
                  className="pp-btn-check"
                  onClick={checkPayment}
                  disabled={!isCheckPaymentEnabled}
                >
                  {isCheckPaymentEnabled
                    ? <><CheckIcon /> ตรวจสอบการชำระเงิน</>
                    : <><RefreshIcon /> กำลังตรวจสอบ…</>
                  }
                </button>
                {!isCheckPaymentEnabled && (
                  <div className="pp-cooldown-bar">
                    <div className="pp-cooldown-fill" style={{ width: `${cooldownPct}%` }} />
                  </div>
                )}
                <button
                  className="pp-btn-cancel"
                  onClick={() => cancelOrder(selectedId, false)}
                >
                  <XIcon /> ยกเลิกการชำระเงิน
                </button>
              </div>
            </>
          ) : (
            /* EXPIRED */
            <div className="pp-card">
              <div className="pp-expired">
                <div className="pp-expired-icon">⏰</div>
                <h3>หมดเวลาชำระเงิน</h3>
                <p>รายการนี้ถูกยกเลิกอัตโนมัติเนื่องจากเกินเวลากำหนด</p>
                <Link to="/addticket" className="pp-btn-retry">
                  ↩ ทำรายการใหม่
                </Link>
              </div>
            </div>
          )}
        </div>

        {/* PRIZE MODAL */}
        {showModal && (
          <div className="pp-modal-overlay">
            <div className="pp-modal" role="dialog" aria-modal="true">
              <div className="pp-modal-handle"><span /></div>
              <div className="pp-modal-header">
                <div className="pp-modal-trophy">🏆</div>
                <div className="pp-modal-title">ยินดีด้วย! คุณได้รับสิทธิ์ลุ้นรางวัล</div>
                <div className="pp-modal-sub">
                  ซื้อบัตรวันที่ <strong style={{ color: '#fde68a' }}>11 มกราคม 2568 (วันเด็กแห่งชาติ)</strong><br/>
                  กรอกข้อมูลเพื่อยืนยันสิทธิ์
                </div>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="pp-modal-body">
                  <div className="pp-modal-notice">
                    ⚠️ หากถูกรางวัล ให้ส่งสลิปการชำระเงินเพื่อยืนยันผ่าน Line: <strong>Zoo E-Ticket By @pay</strong>
                    หรือ Facebook: <strong>Zoo E-ticket by Addpay</strong>
                  </div>
                  <div className="pp-field">
                    <label>ชื่อ - นามสกุล</label>
                    <input
                      type="text" name="name" required
                      placeholder="กรอกชื่อของคุณ"
                      value={formData.name}
                      onChange={e => setFormData(p => ({ ...p, name: e.target.value }))}
                    />
                  </div>
                  <div className="pp-field">
                    <label>เบอร์โทรศัพท์</label>
                    <input
                      type="tel" name="phone" required
                      placeholder="0xx-xxx-xxxx"
                      value={formData.phone}
                      onChange={e => setFormData(p => ({ ...p, phone: e.target.value }))}
                    />
                  </div>
                </div>
                <div className="pp-modal-footer">
                  <button type="button" className="pp-modal-skip" onClick={() => setShowModal(false)}>
                    ไม่รับสิทธิ์
                  </button>
                  <button type="submit" className="pp-modal-submit">
                    🎟 ยืนยันรับสิทธิ์
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        <Footer />
      </div>
    </>
  );
}

export default Promptpay;